export const NO_AUTH = {value: 'NO_AUTH', label: 'No Auth'}
export const API_KEY = {value: 'API_KEY', label: 'API Key'}
export const BEARER_TOKEN = {value: 'BEARER_TOKEN', label: 'Bearer Token'}

export const BASIC_AUTH = {value: 'BASIC_AUTH', label: 'Basic Auth'}
export const DIGEST_AUTH = {value: 'DIGEST_AUTH', label: 'Digest Auth'}
export const HAWK_AUTH = {value: 'HAWK_AUTH', label: 'Hawk Auth'}
export const NTLM_AUTH = {value: 'NTLM_AUTH', label: 'Ntlm Auth'}

export const OAUTH_1 = {value: 'OAUTH_1', label: 'Oauth 1.0'}
export const OAUTH_2 = {value: 'OAUTH_2', label: 'Oauth 2.0'}
export const AWS_SIGNATURE = {value: 'AWS_SIGNATURE', label: 'Aws Signature'}
export const AKAMAI_EDGE_GRID = {value: 'AKAMAI_EDGE_GRID', label: 'Akamai EdgeGrid'}